'use client';

import { EffectCallback, useEffect, useRef, useState } from 'react';

export function useEffectOnce(effect: EffectCallback, shouldRun: boolean) {
  const effectExecuted = useRef(false);
  const effectRef = useRef(effect);
  effectRef.current = effect;
  const [dep, setDep] = useState(shouldRun);

  // Update the dependency only if effect hasn't been executed
  useEffect(() => {
    if (!effectExecuted.current) {
      setDep(shouldRun);
    }
  }, [shouldRun]);

  // Run the effect only once when the dependency is true
  useEffect(() => {
    if (!effectExecuted.current && dep) {
      effectExecuted.current = true;

      return effectRef.current();
    }
  }, [dep]);
}
